import '../styles/MediaList.css';
import React from 'react';
import MediaCard from './MediaCard';

const MediaList = ({ media: mediaList, row = false, showDetails = false, isHistory = false }: { media: any[]; row?: boolean; showDetails?: boolean, isHistory?: boolean }) => {
  return (
    <div className={`movie-list ${row ? 'row' : 'grid'}`}>
      {mediaList.length === 0 ? (
        <p>No results found. Try searching for something else!</p>
      ) : (
        mediaList.map((item) => (
          <MediaCard key={item.id} media={item} showDetails={showDetails} />
        ))
      )}
    </div>
  );
  
};

export default MediaList;
